import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { CommunicationListStateType, CommunicationResponseItem, Pagination } from 'src/shared/types/src';

const initialState: CommunicationListStateType = {
  loading: true,
  paginatedLoading: false,
  messages: [],
  pagination: {
    currentPage: 1,
    from: 1,
    itemsPerPage: 0,
    lastPage: 1,
    to: 1,
    totalItems: 1,
  },
};

const communicationSlice = createSlice({
  name: 'communicationSlice',
  initialState,
  reducers: {
    setCommunicationLoader: (
      state,
      action: PayloadAction<{ loading: boolean }>
    ) => {
      state.loading = action.payload.loading;
    },
    setCommunicationPaginatedLoader: (
      state,
      action: PayloadAction<{ paginatedLoading: boolean }>
    ) => {
      state.paginatedLoading = action.payload.paginatedLoading;
    },
    appendCommunications: (
      state,
      action: PayloadAction<{ list: CommunicationResponseItem[]; pagination: Pagination }>
    ) => {
      state.pagination = action.payload.pagination;
      state.messages.push(...action.payload.list);
    },
    resetCommunicationState: () => {
      return {
        ...initialState
      };
    },
    updateReadStatus: (state, action: PayloadAction<{ id: number }>) => {
      const messages = state.messages;
      const messageIdx = state.messages.findIndex(
        (obj) => obj.id === action.payload.id
      );
      if (messageIdx === -1) {
        return;
      }
      const updatedObj: CommunicationResponseItem = {
        ...messages[messageIdx],
        isRead: true,
      };
      state.messages = [
        ...messages.slice(0, messageIdx),
        updatedObj,
        ...messages.slice(messageIdx + 1),
      ];
    },
  },
});

export const CommunicationActions = communicationSlice.actions;
export default communicationSlice.reducer;
